import PersonIconSvg from "src/components/svg/PersonIconSvg";
import theme from "src/components/themes/DefaultTheme";
import styled, { css } from 'src/lib/styles/css';
import { useState } from "react";

//#region [Props]
type ProfileImageProps = {
	pictureUrl?: string;
	userName?: string;
	className?: string;
	userId: string;
	hasUploadedPicture?: boolean;
};
//#endregion

//#region [Component]
export default function ProfileImage({ pictureUrl, userName, userId, className, hasUploadedPicture }: ProfileImageProps) {
	const [errorProfilePic, setErrorProfilePic] = useState(false);

	const picUrl = (hasUploadedPicture ? `${process.env.NEXT_PUBLIC_FILMWEBIDAPI_BASE}/api/Picture?userId=${userId}` : pictureUrl);

	const _userName = userName === "GDPRDELETED" ? null : userName;

	return (
		<SPortrait $hasNoProfilePic={!picUrl || errorProfilePic} className={className}>
			{(!picUrl || errorProfilePic) && <SPersonIconSvg  />}
			{(picUrl && !errorProfilePic) && <SUserImage src={picUrl} alt={userName || "Filmweb bruker"} onError={() => setErrorProfilePic(true)} />}
		</SPortrait>
	);
}
//#endregion

//#region [Styles]
type SPortraitProps = {
	$hasNoProfilePic: boolean;
}

const SPortrait = styled.div<SPortraitProps>`
	box-sizing: border-box;
	width: var(--portrait-size, 75px);
	height: var(--portrait-size, 75px);
	border-radius: 50%;
	position: relative;
	overflow: hidden;
	background-color: ${theme.palette.lilla4};

	${props => props.$hasNoProfilePic ? css`
		border: 2px solid ${theme.palette.turkis2};
	`:""}
`;

const SPersonIconSvg = styled(PersonIconSvg)`
	width: 100%;
	height: 100%;
	fill: var(--textcolor);
`;

const SUserImage = styled.img`
	width: 100%;
	display: block;
`;
//#endregion